import { partyLinks } from "@/mocks/partes";
import PartyRoleBadge from "./PartyRoleBadge";

const linkStatusColors: Record<string, string> = {
  "Ativo": "bg-primary-100 text-primary-700",
  "Pendente": "bg-warning-100 text-warning-700",
  "Em revisão": "bg-warning-50 text-warning-600",
  "Encerrado": "bg-background-100 text-foreground-500",
  "Suspenso": "bg-danger-100 text-danger-700",
  "Substituído": "bg-background-200 text-foreground-400",
};

export default function PartyRolesTable() {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-semibold text-foreground-900">Papéis e vínculos das partes</h3>
        <span className="text-xs text-foreground-400">{partyLinks.length} vínculos</span>
      </div>
      <div className="overflow-x-auto bg-white rounded-xl border border-background-200/70">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-background-200 bg-background-50/50">
              <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Parte</th>
              <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Papel</th>
              <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider hidden md:table-cell">Projeto/Unidade</th>
              <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider hidden lg:table-cell">Documento fonte</th>
              <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider hidden xl:table-cell">Início</th>
              <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Status</th>
            </tr>
          </thead>
          <tbody>
            {partyLinks.map((link) => (
              <tr key={link.id} className="border-b border-background-100 hover:bg-background-50/50 transition-colors">
                <td className="px-4 py-3">
                  <p className="text-sm font-medium text-foreground-900">{link.partyName}</p>
                </td>
                <td className="px-4 py-3"><PartyRoleBadge role={link.role} /></td>
                <td className="px-4 py-3 hidden md:table-cell">
                  <p className="text-xs text-foreground-700">{link.projectName}</p>
                  {link.environmentalUnitName !== "—" && (
                    <p className="text-xs text-foreground-400">{link.environmentalUnitName}</p>
                  )}
                </td>
                <td className="px-4 py-3 text-xs text-foreground-500 hidden lg:table-cell">{link.sourceDocumentName}</td>
                <td className="px-4 py-3 text-xs text-foreground-500 hidden xl:table-cell">{link.startDate}</td>
                <td className="px-4 py-3">
                  <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${linkStatusColors[link.status] || "bg-background-100 text-foreground-500"}`}>
                    {link.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}